import React, { useEffect, useState } from "react";

import i18n, { loadMaori } from "@/i18n/i18n";
import { LanguageContext, type Language } from "./language-context";

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [language, setLanguage] = useState<Language>(() => {
        const saved = localStorage.getItem("language");
        if (saved === "en" || saved === "mi") return saved;
        return "en";
    });

    // Keep i18n and <html lang> in sync whenever language changes.
    // Also ensures the Māori bundle is loaded when the saved language is "mi"
    // (e.g. on a hard reload - the bundle is only bundled on first toggle otherwise).
    useEffect(() => {
        let isMounted = true;

        void (async () => {
            if (language === "mi") {
                await loadMaori();
            }

            if (!isMounted) return;

            await i18n.changeLanguage(language);
            document.documentElement.lang = language;
            localStorage.setItem("language", language);
        })();

        return () => {
            isMounted = false;
        };
    }, [language]);

    const toggleLanguage = async () => {
        const next: Language = language === "en" ? "mi" : "en";
        if (next === "mi") {
            await loadMaori();
        }
        setLanguage(next);
    };

    return <LanguageContext.Provider value={{ language, toggleLanguage: () => void toggleLanguage() }}>{children}</LanguageContext.Provider>;
};
